export default __webpack_public_path__ + "static/media/partner_signup_background.5ecfa73e.jpg";